"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersListRequestSort = void 0;
exports.UsersListRequestSort = {
    CreatedOnAscending: "CreatedOn",
    CreatedOnDescending: "-CreatedOn",
    EmailAscending: "Email",
    EmailDescending: "-Email",
    StatusAscending: "Status",
    StatusDescending: "-Status",
    LastLoginAscending: "LastLogin",
    LastLoginDescending: "-LastLogin",
    UpdatedOnAscending: "UpdatedOn",
    UpdatedOnDescending: "-UpdatedOn",
};
